import { useSubject } from '@guidedchoice/scrinium';
import { PaymentMethodsData } from '../../api/apis/PaymentApi';
import { PaymentServices } from '../../data/payment';

export function usePaymentMethods() {
  const paymentMethodsSubject = useSubject<PaymentMethodsData[]>(PaymentServices.PaymentMethods);
  return paymentMethodsSubject;
}
